import React from 'react'
import NavItem from '../../Layout/NavItem'
import { NavItemProps } from '../../Layout/NavItem'

const VendorNavItem: React.FC<NavItemProps> = (props) =>
  <NavItem {...props} base='vendor' />

export default VendorNavItem